<style scoped>
.team-image {
    width: 75px;
    height: 75px;
}
@media screen and (min-width: 450px) {
    .team-image {
        width: 100px;
        height: 100px;
    }
}

@media (max-width: 768px) {
    .center-part {
        max-width: calc(100vw - 180px);
    }
}
</style>

<template>
    <v-card class="d-flex align-center" @click="goToMatch()">
        <div class="ml-2" v-if="opponent">
            <img :src="'/api/public/image/get?size=200x200&type=team&id=' + opponent.id" class="team-image" />
        </div>
        <div class="flex-grow-1 d-flex flex-column justify-center ml-2 center-part">
            <div class="font-weight-bold" v-if="match.name">{{match.name}}</div>
            <div class="font-weight-bold" v-if="opponent">{{opponent.name}}</div>
            <div>
                <v-icon small>mdi-calendar</v-icon>
                {{Date.formatFullLong(match.activity.startTime, !$vuetify.breakpoint.mobile).capitalize()}}
            </div>
        </div>
        <teamsport-book-match :match="match" :bookingOption="getBookingOption" :teamId="teamId" class="mr-1" v-if="ourTeam && ourTeam.group" />
    </v-card>
</template>

<script>
import TeamsportBookMatch from './TeamsportBookMatch.vue'
export default {
    name: 'zoezi-teamsport-coming-match',

    props: ['match', 'teamId'],

    components: {
        TeamsportBookMatch
    },

    computed: {
        opponents() {
            if (!this.match) {
                return [];
            }
            return this.match.teams.filter(t => t.id != this.teamId);
        },
        opponent() {
            if (this.opponents.length == 0) {
                return null;
            }
            return this.opponents[0];
        },
        ourTeam() {
            if (!this.match) {
                return null;
            }
            return this.match.teams.find(t => t.id == this.teamId);
        },
        getBookingOption() {
            return this.ourTeam?.group?.bookingOption;
        }
    },
    methods: {
        goToMatch() {
            const matchPage = this.$root.siteconfig?.pages?.match;
            this.$root.followLink(matchPage, this.match.id);
        },
    }
}

</script>

<!-- FIXME: If more than one opponent -->
